import {API_URL} from "../../../../URL";
import {SET_BOARD, SET_LABELS} from "../../../constants";

export const LabelsAPI = () => {
    return async (dispatch) => {
        const data = await (await fetch(API_URL + "/get/all_labels/")).json();

        dispatch({type: SET_LABELS, payload: data})
    }
}
export const HandleLabelsAPI = (card_id, label_id, is_checked) => {
    return async (dispatch) => {
        const response = await fetch(API_URL + "/post/handle_card_label/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                card_id,
                label_id,
                is_checked,
            }),
        });

        const data = await response.json();
    };
};